export enum AnnouncementContent {
    COMPANY_VALUATION = 'Company Valuation',
}
